import type { Point } from 'pixi.js';
import { Container } from 'pixi.js';
import type { CustomTaskBubble } from './TaskScoreOverlay';
import { StarTaskBubbleLayout } from '../../../layouts/scoring/StarTaskBubbleLayout';
import { playLayoutAnimation } from '../../libs/layouts/layoutAnimations/playLayoutAnimation';
import type { TaskScoreBubbleAnimator } from './TaskScoreBubbleAnimator';
import { waitForMs } from '../../utils/async-utils';
import { EasingMap } from '../../libs/TweenManager/easing';

export class StarTaskBubbleView extends Container implements CustomTaskBubble {
  private readonly layout = new StarTaskBubbleLayout();

  constructor(private readonly bubbleAnimator: TaskScoreBubbleAnimator) {
    super();

    const { root } = this.layout;

    root.props({
      parent: this,
    });
  }

  public async animateTo(target: Point, onComplete: () => void): Promise<void> {
    void this.animateFrames(500, 100);
    await playLayoutAnimation(this.layout, 'starAppearing');
    await this.bubbleAnimator.standardToTarget(this.layout.starContainer, target);
    onComplete();
  }

  private async animateFrames(duration: number, delay: number): Promise<void> {
    const { star, starOverlay, root } = this.layout;

    const frames = [
      { texture: 'Animation_Star_1', scaleX: 1 },
      { texture: 'Animation_Star_2', scaleX: 1 },
      { texture: 'Animation_Star_3', scaleX: 1 },
      { texture: 'Animation_Star_4', scaleX: 1 },
      { texture: 'Animation_Star_5', scaleX: 1 },
      { texture: 'Animation_Star_4', scaleX: -1 },
      { texture: 'Animation_Star_3', scaleX: -1 },
      { texture: 'Animation_Star_2', scaleX: -1 },
      { texture: 'Animation_Star_1', scaleX: 1 },
    ];

    await waitForMs(delay);

    if (root.destroyed) return;

    this.tweens.createValueTween(
      0,
      frames.length,
      duration,
      (value) => {
        if (root.destroyed) return;
        const frame = frames[Math.floor(value)];
        if (!frame) return;

        star.props(frame);
        starOverlay.props(frame);
      },
      EasingMap.sinInOut,
    );
  }
}
